<!-- <p>video-resource works!</p> -->
<div class="container-fluid" style="margin-top: 60px;">
    <div class="row justy-content-center mx-auto p-3">
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Distinctio suscipit hic deserunt, nihil tenetur eum
        porro labore, voluptas, exercitationem ducimus tempore eaque. Laudantium expedita dignissimos in cupiditate,
        pariatur dolore unde!
        <div class="col-md-6" *ngFor="let item of resources">
            <div class="card border-0 shadow-sm">
                <mat-video [keyboard]="false" #video src="{{item}}"></mat-video>
                <video id="player" playsinline controls>
                    <source [src]="item" type="video/mp4" />
                    <!-- <source src="/path/to/video.webm" type="video/webm" /> -->
                </video>

                <div class="card-body _card-body">
                    <div class="container">
                        <a href="#" class="" [download]="showurl">
                            <button class="btn download-btn" (click)="downLoadEncryptFile()">Download <span
                                    class="fa fa-download"></span></button>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>